// src/components/common/CreateSixModal/CreateSixModal.tsx
import React from 'react';
import { useSelector } from 'react-redux';

import AppModal from '@/components/common/AppModal/AppModal';
import { useAppDispatch } from '@/store';
import { selectIsCreateSixModal } from '@/store/selectors/ui';
import { hideModal } from '@/store/thunks/ui/uiThunk';
import { resetCreateSixState } from '@/store/slices/createSix/createSixSlice';
import {
  selectShowSuccessScreen,
  selectStep,
  selectSubmitting,
} from '@/store/selectors/createSix';
import CreateSixStepper from '@/components/organism/CreateSix/CreateSixStepper';
import { getStepConfig } from '@/components/organism/CreateSix/stepConfig';
import StepSuccess from '@/components/organism/CreateSix/steps/StepSuccess';

const CreateSixModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const isOpen = useSelector(selectIsCreateSixModal);
  const step = useSelector(selectStep);
  const showSuccessScreen = useSelector(selectShowSuccessScreen);
  const isSubmitting = useSelector(selectSubmitting);

  if (!isOpen) return null;

  // Compute modal header info
  const { title, iconTooltip, infoIcon } = getStepConfig(step);
  let modalTitle = title;
  let modalIconTooltip = iconTooltip;
  let modalInfoIcon = infoIcon;

  if (showSuccessScreen) {
    modalTitle = 'Invitation sent!';
    modalIconTooltip = undefined;
    modalInfoIcon = undefined;
  }

  const handleClose = () => {
    dispatch(hideModal());
    dispatch(resetCreateSixState());
  };

  return (
    <AppModal
      onClose={handleClose}
      title={modalTitle}
      iconTooltip={modalIconTooltip}
      infoIcon={modalInfoIcon}
      showLoader={isSubmitting}
    >
      {showSuccessScreen ? (
        <StepSuccess />
      ) : (
        <CreateSixStepper onClose={handleClose} />
      )}
    </AppModal>
  );
};

export default CreateSixModal;
